import {GetValues_ForSchema} from "js-vextensions";
import {TriggerSet} from "../@TriggerSet.js";
import {EffectPointer} from "../../@Shared/EffectPointer.js";
import {AddSchema} from "mobx-graphlink";

export class EngineConfig_Signals {
	constructor(data: Partial<EngineConfig_Signals>) { Object.assign(this, data); }

	enabled: boolean;

	signals: SignalConfig[];
}
AddSchema("EngineConfig_Signals", {
	properties: {
		enabled: {type: "boolean"},

		signals: {items: {$ref: "SignalConfig"}},
	},
});

export class SignalConfig {
	constructor(data: Partial<SignalConfig>) { Object.assign(this, data); }

	name: string;
	triggerSet: TriggerSet;
	effect = new EffectPointer();
	graphColor: number[];
	graphVMin: number;
	graphVMax: number;
}
AddSchema("SignalConfig", {
	properties: {
		name: {type: "string"},
		triggerSet: {$ref: "TriggerSet"},
		effect: {$ref: "EffectPointer"},
		graphColor: {items: {type: "number"}},
		graphVMin: {type: "number"},
		graphVMax: {type: "number"},
	},
});